import { render } from "./addProduct.vue?vue&type=template&id=5b11088d&scoped=true"
import script from "./addProduct.vue?vue&type=script&lang=js"
export * from "./addProduct.vue?vue&type=script&lang=js"

import "./addProduct.vue?vue&type=style&index=0&id=5b11088d&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b11088d"]])

export default __exports__